const t = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      skills: 'Skills',
      work: 'Work',
      projects: 'Projects',
      contact: 'Contact',
    },
    home: {
      titles: ['Systems Engineer', 'Cloud Architect', 'Robotics Builder', 'DevOps Practitioner'],
      suffix: '@ Amazon Robotics',
      description: "I build large-scale cloud infrastructure and developer tooling at Amazon Robotics. Outside of work, I'm exploring the intersection of LLMs and physical robotics systems. Browse my work experience and projects, or get in touch if you'd like to collaborate.",
      cta_work: 'View My Experience',
      cta_contact: 'Get in Touch',
    },
    about: {
      heading: 'About Me',
      p1: "I'm Akash Balani, a Systems & Cloud Engineer at Amazon Robotics, where I work on large-scale infrastructure, internal developer tooling, and cloud operations supporting tens of thousands of users. I hold a degree from Northeastern University and have previously worked at PwC and AssureCare.",
      p2: "My technical focus is on AWS, Kubernetes, CI/CD, and DevOps — with a growing interest in LLM-integrated systems and robotics. I'm currently building an LLM-powered robot recovery system using ROS2 and the Claude API.",
      p3: "Outside of work, I swim, box, and play piano. I'm also learning French and Spanish — I find that picking up new languages keeps the mind sharp in ways that engineering alone doesn't.",
    },
    skills: {
      heading: 'Skills',
      groups: [
        { category: 'Cloud & Infrastructure', items: ['AWS', 'Azure', 'Kubernetes', 'Docker', 'Terraform', 'AWS CDK'] },
        { category: 'Languages', items: ['Java', 'Python', 'C++', 'JavaScript', 'TypeScript', 'Shell'] },
        { category: 'DevOps & Observability', items: ['CI/CD', 'Datadog', 'Ansible', 'Git', 'ELK Stack', 'ROS2'] },
        { category: 'Data & Databases', items: ['MySQL', 'MongoDB', 'Elasticsearch', 'ETL Pipelines'] },
      ],
    },
    work: { heading: 'Work Experience' },
    projects: {
      heading: 'Projects',
      viewOn: 'View on GitHub',
    },
    contact: {
      heading: 'Contact Me',
      description: 'Feel free to reach out if you have any questions, collaboration requests, or just want to say hello!',
    },
    footer: {
      copyright: `© ${new Date().getFullYear()} Akash Balani`,
    },
  },

  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      skills: 'Compétences',
      work: 'Expérience',
      projects: 'Projets',
      contact: 'Contact',
    },
    home: {
      titles: ['Ingénieur Systèmes', 'Architecte Cloud', 'Développeur Robotique', 'Praticien DevOps'],
      suffix: '@ Amazon Robotics',
      description: "Je construis des infrastructures cloud à grande échelle et des outils pour développeurs chez Amazon Robotics. En dehors du travail, j'explore l'intersection des LLMs et des systèmes robotiques physiques. Parcourez mon expérience et mes projets, ou contactez-moi si vous souhaitez collaborer.",
      cta_work: 'Voir Mon Expérience',
      cta_contact: 'Me Contacter',
    },
    about: {
      heading: 'À Propos',
      p1: "Je suis Akash Balani, ingénieur systèmes et cloud chez Amazon Robotics, où je travaille sur des infrastructures à grande échelle, des outils internes pour développeurs, et des opérations cloud supportant des dizaines de milliers d'utilisateurs. Je suis diplômé de la Northeastern University et j'ai précédemment travaillé chez PwC et AssureCare.",
      p2: "Mon domaine technique principal est AWS, Kubernetes, CI/CD et DevOps — avec un intérêt croissant pour les systèmes intégrant des LLMs et la robotique. Je construis actuellement un système de récupération robotique alimenté par LLM, utilisant ROS2 et l'API Claude.",
      p3: "En dehors du travail, je nage, je fais de la boxe et je joue du piano. J'apprends aussi le français et l'espagnol — je trouve que l'apprentissage de nouvelles langues maintient l'esprit vif d'une manière que l'ingénierie seule ne peut pas faire.",
    },
    skills: {
      heading: 'Compétences',
      groups: [
        { category: 'Cloud & Infrastructure', items: ['AWS', 'Azure', 'Kubernetes', 'Docker', 'Terraform', 'AWS CDK'] },
        { category: 'Langages', items: ['Java', 'Python', 'C++', 'JavaScript', 'TypeScript', 'Shell'] },
        { category: 'DevOps & Observabilité', items: ['CI/CD', 'Datadog', 'Ansible', 'Git', 'ELK Stack', 'ROS2'] },
        { category: 'Données & Bases de données', items: ['MySQL', 'MongoDB', 'Elasticsearch', 'Pipelines ETL'] },
      ],
    },
    work: { heading: 'Expérience Professionnelle' },
    projects: {
      heading: 'Projets',
      viewOn: 'Voir sur GitHub',
    },
    contact: {
      heading: 'Me Contacter',
      description: "N'hésitez pas à me contacter si vous avez des questions, des demandes de collaboration, ou si vous souhaitez simplement dire bonjour !",
    },
    footer: {
      copyright: `© ${new Date().getFullYear()} Akash Balani`,
    },
  },
};

export default t;
